import React, { Component } from "react";
import ReactPaginate from 'react-paginate';
import moment from 'moment';

import {
    Table,
    Form, FormGroup, Label,
    Input, InputGroup, InputGroupAddon, InputGroupText,
    UncontrolledPopover, PopoverHeader, PopoverBody,
    UncontrolledTooltip,
    Alert
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faShareAltSquare, faFilePdf, faCopy, faClone, faInfoCircle, faExclamationTriangle, faTrash, faTrashRestore, faDownload } from '@fortawesome/free-solid-svg-icons'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import PdfPreview from './PdfPreview';

class Pagination extends Component {
    state = {
        data: [],
        page_count: 0,
        page_size: 20,
        page: 0,
        tooltipOpen: false,
        popoverOpen: false,
        setTooltipOpen: false,
        show_archived: false
    }

    constructor(props){
        super(props);

        this.URL = this.props.url;
        this.DATA_ATTR = this.props.data_attr
        this.REDIRECT_TO = this.props.redirect_to;

        this.SHOW_INCOMPLETE = this.props.show_incomplete ? 1 : 0;
        this.SHOW_UV_ATTRIBUTES = this.props.show_uv_attributes === true;

        this.PAGE_SIZE_KEY = this.props.page_size_key;
        let page_size = localStorage.getItem(this.PAGE_SIZE_KEY) || 20;
        this.state.page_size = page_size;
        this.state.show_archived = this.props.show_archived || false;

        this.getList(1);
    }

    getList = async (new_page, show_archived = null) => {
        let token = JSON.parse(localStorage.getItem("token"));
        let archived = show_archived !== null ? show_archived : this.state.show_archived;
        var result = await fetch(this.URL + '?page=' + new_page + '&page_size=' + this.state.page_size + "&show_archived=" + (archived ? 1 : 0) + "&show_incomplete=" + this.SHOW_INCOMPLETE, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data);
            return data;
        })
        .catch((error) => {
            return error;
        });
        // console.log(result);
        if(result["meta"]){
            this.setState({
                data: result[this.DATA_ATTR] ?  result[this.DATA_ATTR] : [],
                page_count: result["meta"]['page_count'],
                page: new_page - 1
            });
        }
    }

    handlePageClick = (data) => {
        //console.log(data);
        this.getList(data.selected + 1);
    }

    handleChange = (e) => {
        localStorage.setItem(this.PAGE_SIZE_KEY, e.target.value);
        this.setState({
            page_size: e.target.value
        }, () => {
            this.getList(1);
        })
    }

    getIndex = (index) => {
        if(this.state.page == 0){
            return (index + 1);
        }else{
            return (this.state.page*this.state.page_size) + (index + 1);
        }
    }

    toggleArchived = () => {
        const newShowArchived = !this.state.show_archived;
        this.setState({ show_archived: newShowArchived }, () => {
            this.getList(1);
        });
    }

    toggleTooltip = () => {
        this.setState({tooltipOpen: !this.state.tooltipOpen})
        return this.state.toggleTooltip
    }

    togglePopover = () => {
        this.setState({popoverOpen: !this.state.popoverOpen})
        return this.state.togglePopover
    }

    selectShareUrl = (event) => {
        if (this.state.popoverOpen) {
            event.target.select();
        }
    }


    copyDataToClipboard = (data) => {
        let share_url = this.shareUrl(data);
        navigator.clipboard.writeText(share_url)
        toast.success('Copied share link to clipboard');
    }

    shareUrl = (data) => {
        return window.location.origin + "/" + this.REDIRECT_TO + "/new?public_key=" + data
    }

    downloadTextFile = async (designId) => {
        let token = JSON.parse(localStorage.getItem("token"));
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + '/api/v4/box_designs/' + designId + '/download', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                toast.error('Failed to get download link');
                return;
            }

            const data = await response.json();
            if (data.download_url) {
                window.open(data.download_url, '_blank');
            } else {
                toast.error('Download URL not available');
            }
        } catch (error) {
            toast.error('Error downloading file');
        }
    }

    archiveItem = async (item) => {
        const newArchivedState = item.is_archived ? 0 : 1;
        const action = newArchivedState === 1 ? 'deleted' : 'restored';

        let token = JSON.parse(localStorage.getItem("token"));

        // First, fetch the full design data to preserve all fields
        const fullDataResponse = await fetch(this.URL + '/' + item.id, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                'Content-Type': 'application/json'
            }
        });

        const fullData = await fullDataResponse.json();
        const designKey = this.DATA_ATTR.slice(0, -1); // e.g., 'box_design' from 'box_designs'

        if (!fullData[designKey]) {
            toast.error('Failed to fetch template data.');
            return;
        }

        const design = fullData[designKey];

        // Build the update body with all existing data, only changing is_archived
        const updateBody = {
            name: design.name,
            enclosure_type: design.enclosure_type,
            is_public: design.is_public,
            is_archived: newArchivedState
        };

        // Include holes if they exist (for box_designs)
        if (design.box_design_holes) {
            updateBody.holes = design.box_design_holes.map(h => ({
                box_side: h.box_side,
                diameter: h.diameter,
                positionX: h.position_x,
                positionY: h.position_y
            }));
        }

        // Include lines if they exist
        if (design.box_design_lines) {
            updateBody.lines = design.box_design_lines.map(l => ({
                box_side: l.box_side,
                positionX1: l.position_x1,
                positionY1: l.position_y1,
                positionX2: l.position_x2,
                positionY2: l.position_y2
            }));
        }

        // Include shapes if they exist
        if (design.box_design_shapes) {
            updateBody.shapes = design.box_design_shapes.map(s => ({
                box_side: s.box_side,
                shape_type: s.shape_type,
                positionX: s.position_x,
                positionY: s.position_y,
                width: s.width,
                height: s.height
            }));
        }

        // Include UV design specific fields if they exist
        if (design.box_side !== undefined) {
            updateBody.box_side = design.box_side;
        }
        if (design.document !== undefined) {
            updateBody.document = design.document;
        }

        var result = await fetch(this.URL + '/' + item.id, {
            method: 'PUT',
            headers: {
                Authorization: "Bearer " + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateBody)
        })
        .then(response => response.json())
        .then(data => {
            return data;
        })
        .catch((error) => {
            return error;
        });

        if (result[designKey]) {
            toast.success(`Template successfully ${action}.`);
            this.getList(this.state.page + 1);
        } else {
            if (result["message"]) {
                toast.error(result.message);
            } else {
                toast.error('Failed to update template.');
            }
        }
    }

    render() {
        return (
            <div>
                <ToastContainer
                    position="bottom-center"
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable={false}
                    pauseOnHover={false}
                />
                <div style={{position: "relative"}}>
                    <div style={{position: "absolute", right: "10px", top: "10px"}}>
                        <div>
                            {this.state.show_archived &&
                                <span className="badge badge-secondary mr-2">Viewing Deleted</span>
                            }
                            <button
                                type="button"
                                className="btn btn-link p-0"
                                onClick={this.toggleArchived}
                            >
                                {this.state.show_archived ? 'Show Active Templates' : 'Show Deleted Templates'}
                            </button>
                        </div>
                    </div>
                </div>
                {this.state.data.length === 0 &&
                    <div className="text-center text-muted py-4">
                        {this.state.show_archived
                            ? 'No deleted templates found.'
                            : 'No templates found.'}
                    </div>
                }
                {this.state.data.length > 0 &&
                    <div>
                        <Table>
                            <thead>
                                <tr>
                                    <th style={{width: '2%'}}></th>
                                    {this.SHOW_UV_ATTRIBUTES === true && (
                                        <th style={{width: '10%'}}>Preview</th>
                                    )}
                                    <th style={{width: '23%'}}>Name</th>
                                    <th style={{width: '15%'}}>Enclosure</th>
                                    <th style={{width: '15%'}}>Created</th>
                                    <th style={{width: '25%'}}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data.map((item, index) => {

                                        return <tr key={item.id}>
                                            <td>{this.getIndex(index)}</td>
                                            {item["document_url"] && !item["file_error"] && (
                                                <td className="align-middle">
                                                    <PdfPreview
                                                        file={item.document_url}
                                                        thumbnailWidth={70}
                                                        title={item.name}
                                                    />
                                                </td>
                                            )}
                                            <td>{item.name}</td>
                                            <td>
                                                {item.enclosure_type}
                                                {item["box_side"] &&
                                                    <div>Side: {item["box_side"]}</div>
                                                }
                                                {this.SHOW_UV_ATTRIBUTES && (() => {
                                                    const hasWhite = item["white_layer"] === "Yes";
                                                    const hasCmyk = item["color_layer"] === "Yes";
                                                    const hasGloss = item["gloss_layer"] === "Yes";
                                                    const hasAny = hasWhite || hasCmyk || hasGloss;
                                                    if (!hasAny) {
                                                        return (
                                                            <Alert color="danger" className="mt-1 mb-0 p-2">
                                                                <span className="font-weight-bold">Alert! </span>
                                                                You didn't check any of the layer settings for CMYK, White, or Gloss. The file must have at least one of these attributes assigned.
                                                            </Alert>
                                                        );
                                                    }
                                                    return (
                                                        <div className="mt-1">
                                                            {hasCmyk && <span className="badge badge-warning ml-1">CMYK Color</span>}
                                                            {hasWhite && <span className="badge badge-secondary ml-1">RDG White Spot Color</span>}
                                                            {hasGloss && (
                                                                <span className="badge badge-info ml-1">
                                                                    RDG Gloss Spot Color{item["gloss_print_type"] ? " (" + item["gloss_print_type"] + ")" : ""}
                                                                </span>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </td>
                                            <td>
                                                <div className="text-small">{moment(item.created_at).format("MMM DD YYYY h:mm")}</div>
                                            </td>
                                            <td className="text-left align-middle">
                                                {item["active_box_job"] === true &&
                                                    <div className="my-2">
                                                        <span id={"InProgressTooltip"+ item.id}><FontAwesomeIcon className="fa-md" icon={faInfoCircle} />Job In Progress</span>
                                                        <UncontrolledTooltip placement="left" target={"InProgressTooltip"+ item.id}>
                                                            Design templates can be edited until they are assigned to an in progress box job.
                                                        </UncontrolledTooltip>

                                                    </div>
                                                }
                                                {item["file_error"] &&
                                                    <div className="my-2">
                                                        <span id={"FileErrorTooltip"+ item.id}><FontAwesomeIcon className="fa-md" color="red" icon={faExclamationTriangle} /></span>
                                                        <UncontrolledTooltip placement="left" target={"FileErrorTooltip"+ item.id}>
                                                            {item["file_error"]}
                                                        </UncontrolledTooltip>

                                                    </div>
                                                }

                                                {item["document_url"] && !item["file_error"] &&
                                                    <span className="m-2">
                                                        <a href={item.document_url} id={"DownloadTooltip"+ item.id} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon className="fa-lg" icon={faFilePdf} /></a>
                                                        <UncontrolledTooltip placement="bottom" target={"DownloadTooltip"+ item.id}>
                                                            Download Design
                                                        </UncontrolledTooltip>
                                                    </span>
                                                }

                                                <span className="m-2">
                                                    <a href="#" id={"DownloadTextTooltip"+ item.id} onClick={(e) => {e.preventDefault(); this.downloadTextFile(item.id)}}><FontAwesomeIcon className="fa-lg" icon={faDownload} /></a>
                                                    <UncontrolledTooltip placement="bottom" target={"DownloadTextTooltip"+ item.id}>
                                                        Download Text File
                                                    </UncontrolledTooltip>
                                                </span>

                                                {item["active_box_job"] === false &&
                                                    <span className="m-2">
                                                        <a href={this.REDIRECT_TO + "/edit?id=" + item.id} id={"EditTooltip"+ item.id} title="Edit Design"><FontAwesomeIcon className="fa-lg" icon={faEdit} /></a>
                                                        <UncontrolledTooltip placement="bottom" target={"EditTooltip" + item.id}>
                                                            Edit Design
                                                        </UncontrolledTooltip>
                                                    </span>
                                                }

                                                {(item["box_design_holes"] || item["flat_design_holes"]) &&
                                                    <span className="m-2">
                                                        <a href={this.REDIRECT_TO + "/new?id=" + item.id} id={"DuplicateTooltip"+ item.id} title="Duplicate Design"><FontAwesomeIcon className="fa-lg" icon={faClone} /></a>
                                                        <UncontrolledTooltip placement="bottom" target={"DuplicateTooltip"+ item.id}>
                                                            Duplicate Design
                                                        </UncontrolledTooltip>
                                                    </span>
                                                }

                                                {item["public_key"] != null &&
                                                    <span className="m-2">
                                                        <a href="#" id={"ShareTooltip"+ item.id}><FontAwesomeIcon id={"Popover1"+ item.id} className="fa-lg text-primary" onClick={(e) => {e.preventDefault();}} icon={faShareAltSquare} /></a>
                                                        <UncontrolledTooltip placement="right" target={"ShareTooltip"+ item.id}>
                                                            Share Design
                                                        </UncontrolledTooltip>
                                                        <UncontrolledPopover className="share-popup" placement="left" target={"Popover1"+ item.id}>
                                                            <PopoverHeader>Share Link</PopoverHeader>
                                                            <PopoverBody>
                                                                <div>
                                                                <InputGroup>
                                                                    <Input readOnly className="share-url float-left p-1" key="share_url" id="share_url" name="share_url" placeholder="Share Url" onClick={this.selectShareUrl} value={this.shareUrl(item.public_key)} />
                                                                    <InputGroupAddon addonType="append">
                                                                        <InputGroupText><FontAwesomeIcon className="fa-lg float-left text-primary" onClick={(e) => {e.preventDefault(); this.copyDataToClipboard(item.public_key)}} icon={faCopy} /></InputGroupText>
                                                                    </InputGroupAddon>
                                                                </InputGroup>
                                                                </div>
                                                            </PopoverBody>
                                                        </UncontrolledPopover>
                                                    </span>
                                                }

                                                {item["active_box_job"] === false &&
                                                    <span className="m-2">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0"
                                                            id={"ArchiveTooltip"+ item.id}
                                                            onClick={(e) => {e.preventDefault(); this.archiveItem(item)}}
                                                        >
                                                            <FontAwesomeIcon
                                                                className="fa-lg"
                                                                color={item.is_archived ? "green" : "gray"}
                                                                icon={item.is_archived ? faTrashRestore : faTrash}
                                                            />
                                                        </button>
                                                        <UncontrolledTooltip placement="bottom" target={"ArchiveTooltip"+ item.id}>
                                                            {item.is_archived ? 'Restore Template' : 'Delete Template'}
                                                        </UncontrolledTooltip>
                                                    </span>
                                                }
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-between">
                            { this.state.page_count > 1 && (
                                <div>
                                    <div style={{padding: '4px 0px'}}>
                                        <Form>
                                            <FormGroup className="form-inline form-short">
                                                <Label className="mr-1">Shows: </Label>
                                                <Input type="select" name="select" id="exampleSelect" onChange={this.handleChange} value={this.state.page_size}>
                                                    <option>10</option>
                                                    <option>20</option>
                                                    <option>50</option>
                                                    <option>100</option>
                                                </Input>
                                            </FormGroup>
                                        </Form>
                                    </div>
                                    <ReactPaginate
                                        previousLabel={'Previous'}
                                        nextLabel={'Next'}
                                        breakLabel={'...'}
                                        breakClassName={'break-me'}
                                        pageCount={this.state.page_count}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={5}
                                        onPageChange={this.handlePageClick}
                                        containerClassName={'pagination'}
                                        activeClassName={'active'}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                }
            </div>
        )
    }

}
export default Pagination;